import { Helmet } from 'react-helmet';
import SectionCTA from '../components/SectionCTA';
import RiskDisclosure from '../components/RiskDisclosure';

export default function DisclosuresPage() {
  return (
    <main>
      <Helmet>
        <title>Disclosures & Privacy | Carter Asset Management</title>
      </Helmet>
      <section className="section-container section-spacing">
        <div className="max-w-4xl space-y-6">
          <p className="text-sm font-semibold uppercase tracking-wide text-cam-blue/70">Compliance</p>
          <h1 className="text-4xl md:text-5xl font-semibold tracking-tight text-cam-blue">Important Disclosures & Policies</h1>
          <p className="text-base text-slate-600">
            Replace the placeholder language below with compliance-approved content. Include privacy policies, business continuity plans, and regulatory disclosures required by your jurisdiction.
          </p>
        </div>
      </section>
      <section className="section-container pb-16 space-y-10 text-sm text-slate-600">
        <article id="privacy" className="space-y-3">
          <h2 className="text-2xl font-semibold text-cam-blue">Privacy Policy</h2>
          <p>TODO: Insert your firm’s privacy policy covering data collection, sharing, and safeguarding practices.</p>
        </article>
        <article id="important-disclosures" className="space-y-3">
          <h2 className="text-2xl font-semibold text-cam-blue">Important Disclosures</h2>
          <p>TODO: Outline advisory services, fee structure disclosures, and conflicts of interest policies.</p>
        </article>
        <article className="space-y-3">
          <h2 className="text-2xl font-semibold text-cam-blue">Form CRS & Form ADV</h2>
          <ul className="list-disc space-y-2 pl-6">
            <li>
              <a href="/downloads/Form-CRS.pdf" className="underline">Download Form CRS</a>
            </li>
            <li>
              <a href="/downloads/Form-ADV.pdf" className="underline">Download Form ADV Part 2</a>
            </li>
            <li>
              <a href="https://www.investor.gov/CRS" className="underline">Visit Investor.gov/CRS</a>
            </li>
          </ul>
        </article>
        <article className="space-y-3">
          <h2 className="text-2xl font-semibold text-cam-blue">Business Continuity</h2>
          <p>TODO: Summarize business continuity and disaster recovery plans.</p>
        </article>
        <article id="testimonial-policy" className="space-y-3">
          <h2 className="text-2xl font-semibold text-cam-blue">Testimonial Policy</h2>
          <p>
            Testimonials featured on this site reflect the experience of select clients and may not be representative of all clients. They were not compensated and there is no guarantee of similar results. We review testimonials at least annually for accuracy and alignment with SEC Marketing Rule requirements.
          </p>
        </article>
        <article className="space-y-3">
          <h2 className="text-2xl font-semibold text-cam-blue">Client Portal Access</h2>
          <p>Client Portal: <a href="https://client.carteram.com" className="underline">Access here</a></p>
        </article>
        <RiskDisclosure />
      </section>
      <section className="section-container pb-16">
        <SectionCTA
          title="Need additional documentation? Let us know."
          eyebrow="Questions about compliance?"
          buttonText="Contact compliance"
          buttonHref="/contact"
          variant="secondary"
        />
      </section>
    </main>
  );
}
